import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Loading from '../../../components/Common/Loading';
import { actionSendOTP } from '../../../store/application/actions';
import { QUICK_CASH_PRODUCT_CODE } from '../config';
import { QUICK_CASH_ROUTES } from '../routes';
import { saveQuickCashPendingPhone } from '../storage';

function SendPhoneNumber() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  // 최초 진입에서는 기존 신청과 동일하게 신규/기존 고객 선택 화면을 먼저 표시한다.
  const [showCustomerType, setShowCustomerType] = useState(true);
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();

  const onSubmit = async (data) => {
    // OTP 발송 단계부터 상품 코드를 전달해 Backend에서 허용된 상품인지 검증한다.
    const response = await dispatch(actionSendOTP({
      phone: data.phone,
      product_code: QUICK_CASH_PRODUCT_CODE,
    }));
    if (response?.sts_code === 0) {
      // OTP 화면 새로고침에 대비해 인증 전 전화번호만 임시 저장한다.
      saveQuickCashPendingPhone(data.phone);
      navigate(QUICK_CASH_ROUTES.otp, { state: { phone: data.phone } });
    }
  };

  return (
    <>
      <Loading isVisible={isSubmitting} />
      <div className="p-10 pt-36 fixed w-full z-10 top-0 left-0 flex items-start justify-center h-full" style={{ backgroundColor: '#0000004d' }}>
        <div className={`rounded-md w-full border-primary py-6 px-8 bg-white ${showCustomerType ? 'h-[265px]' : ''}`} style={{ maxWidth: 414 }}>
          <p className="text-2xl text-primary2 text-center font-semibold pt-3">
            申請2萬定額貸款
          </p>

          {showCustomerType && (
            <div className="flex justify-center items-center flex-col space-y-6 my-7 mb-16">
              <button
                type="button"
                onClick={() => setShowCustomerType(false)}
                className="rounded-full text-white text-lg px-20 h-[54px] bg-primary"
              >
                新客戶
              </button>
              <button
                type="button"
                onClick={() => setShowCustomerType(false)}
                className="rounded-full text-white text-lg px-20 h-[54px] bg-primary2"
              >
                舊客戶
              </button>
            </div>
          )}

          {!showCustomerType && <form onSubmit={handleSubmit(onSubmit)}>
            <p className="text-gray mt-7 mb-1 text-xl">手提電話號碼</p>
            <input
              {...register('phone', {
                required: true,
                pattern: /^[4-9][0-9]{7}$/g,
                onChange: (event) => setPhone(event.target.value.replace(/[^0-9]/g, '')),
              })}
              value={phone}
              className="border-0 border-b-2 border-primary2 text-primary2 w-full h-10 outline-none px-2"
              maxLength={8}
              inputMode="numeric"
              placeholder="(按此輸入)"
            />
            {errors.phone?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
            {errors.phone?.type === 'pattern' && <span className="text-10 text-red-500">*請輸入正確的手提電話號碼</span>}
            <div className="text-10 mt-8 text-gray">
              <p>
                我們將會發送一次性驗證碼到閣下輸入之手提電話號碼，
                <span className="text-primary">提交前請確認所輸入之手提電話號碼正確無誤。</span>
              </p>
              <p className="mt-2">完成驗證後，現有未完成之申請將由本申請取代。</p>
              <p className="mt-2">
                申請代表您已詳閱並接受我們的
                <a
                  href="https://www.cashingpro.hk/website-terms/"
                  className="text-primary"
                  target="_blank"
                  rel="noreferrer"
                >
                  網站使用條款
                </a>
                及
                <a
                  href="https://www.cashingpro.hk/privacy-policy-and-personal-information-collection-statement/"
                  className="text-primary"
                  target="_blank"
                  rel="noreferrer"
                >
                  私隱政策及收集個人資料聲明
                </a>
                ，亦同意 Cashing Pro Limited 經電話及短訊通知你有關貸款的服務信息
              </p>
            </div>
            <div className="flex justify-center mt-7">
              <button type="submit" disabled={isSubmitting} className={`rounded-full text-white text-base px-12 py-3 ${isSubmitting ? 'bg-mercury' : 'bg-primary'}`}>
                取得驗證碼
              </button>
            </div>
          </form>}
        </div>
      </div>
    </>
  );
}

export default SendPhoneNumber;
